import {observer} from 'mobx-react';
import React from 'react';
import {observable} from 'mobx';
import s from '../s';
import {r} from '../rendering/core';

type Props = {};

@observer
export default class ShareIcon extends React.Component<Props> {
    @observable canShare: boolean = false;

    constructor(props: Props) {
        super(props);
        this.canShare = typeof navigator !== 'undefined' && !!navigator.share;
    }

    render() {
        return (
            this.canShare &&
            s.isRetail && (
                <button
                    type="button"
                    className="share-button"
                    aria-label="Share"
                    onClick={r.share}
                >
                    <i className="fas fa-share-square" />
                </button>
            )
        );
    }
}
